import { RIPPLING } from '@/integrations/modules/rippling/consts';
import type { WagesConfigRequest, WagesConfigResponse } from '@/integrations/modules/rippling/types';
import Integrations from '@/shared/api/integrations';

import { createAsyncThunk } from '@reduxjs/toolkit';

export interface SaveRipplingWagesResponse {
  data: {
    ok: boolean;
  };
}

export const fetchRipplingWagesConfig = createAsyncThunk(
  'rippling/fetchWagesConfig',
  async (_, { rejectWithValue }) => {
    try {
      const response = await Integrations.get(`/${RIPPLING}/v2/config/wages`);
      return response as { data: WagesConfigResponse };
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const saveRipplingWages = createAsyncThunk(
  'rippling/saveWages',
  async (syncWages: boolean, { rejectWithValue }) => {
    try {
      const payload: WagesConfigRequest = { sync_wages: syncWages };
      const response = await Integrations.url(`/${RIPPLING}/v2/config/wages`).post(payload);
      return response as SaveRipplingWagesResponse;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
